import { useRef } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { advocateSelectors } from '../../models/advocate';
import { trackChannelCardView } from '../../models/channels/analytics';
import useInview from '../../common/use-inview';
import {
  ChannelTag,
  ChannelImage,
  ChannelTitle,
  ChannelFollowerCount,
  ChannelFollowButton,
  ChannelDescription,
} from '../channel';
import './channel-card.scss';
import useChannel from '../../common/use-channel';

const ChannelCard = ({
  channelId,
  tag,
  orientation,
  size,
  analyticsData,
  shouldTrackView = true,
  onClick,
}) => {
  const { channel } = useChannel({ channelId });
  const { t } = useTranslation();
  const ref = useRef();
  const isContributor = useSelector(advocateSelectors.getAdvocateIsContributor);

  const className = cx('channel-card', {
    [`channel-card--${orientation}`]: orientation,
    [`channel-card--${size}`]: size,
  });

  const followBtnSize =
    size === 'small' && orientation !== 'landscape' ? 'small' : null;

  const handleView = () => {
    if (shouldTrackView) trackChannelCardView(channelId, analyticsData);
  };
  useInview({
    ref,
    once: true,
    onInview: handleView,
  });

  return channel ? (
    <section className={className} ref={ref}>
      <div className="channel-card__image">
        <ChannelImage
          channel={channel}
          analyticsData={analyticsData}
          onClick={onClick}
        />
      </div>

      <div className="channel-card__contain">
        <div className="channel-card__body">
          <div className="channel-card__text">
            {tag ? <ChannelTag tag={tag} /> : null}

            <ChannelTitle
              channel={channel}
              truncate={2}
              onClick={onClick}
              analyticsData={analyticsData}
            />
            <ChannelDescription
              channel={channel}
              analyticsData={analyticsData}
              truncate={orientation === 'landscape' ? 2 : 5}
            />
          </div>
        </div>

        <div className="channel-card__footer channel-card__footer--spaced">
          <ChannelFollowButton
            channelId={channelId}
            size={followBtnSize}
            analyticsData={analyticsData}
          />

          <ChannelFollowerCount channelId={channel.id} />

          {channel.can_publish_as_owner && isContributor ? (
            <div className="channel__contributor">
              {t('channel_details.contributor')}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  ) : null;
};

ChannelCard.defaultProps = {
  orientation: 'landscape',
};

export default ChannelCard;
